'use strict';

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _setPrototypeOf = require('babel-runtime/core-js/object/set-prototype-of');

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = require('babel-runtime/core-js/object/create');

var _create2 = _interopRequireDefault(_create);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _defineProperty = require('babel-runtime/core-js/object/define-property');

var _defineProperty2 = _interopRequireDefault(_defineProperty);

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; (0, _defineProperty2.default)(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactApollo = require('react-apollo');

var _reactRedux = require('react-redux');

var _reactRouterRedux = require('react-router-redux');

var _reactRouterDom = require('react-router-dom');

var _LoginForm = require('./LoginForm');

var _LoginForm2 = _interopRequireDefault(_LoginForm);

var _withAlertHandler = require('../utility/withAlertHandler');

var _withAlertHandler2 = _interopRequireDefault(_withAlertHandler);

var _apolloClient = require('../../apollo-client');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new _promise2.default(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return _promise2.default.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass; }

var createLoginPage = function createLoginPage(_ref) {
  var userType = _ref.userType,
      redirect = _ref.redirect;

  var LoginPage = function (_Component) {
    _inherits(LoginPage, _Component);

    function LoginPage() {
      var _ref2,
          _this2 = this;

      var _temp, _this, _ret;

      _classCallCheck(this, LoginPage);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = LoginPage.__proto__ || (0, _getPrototypeOf2.default)(LoginPage)).call.apply(_ref2, [this].concat(args))), _this), _this.login = function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee(_ref4) {
          var email = _ref4.email,
              password = _ref4.password;

          var _this$props, client, dispatch, handleSnackbarError, mutate, variables, _ref5, data, desiredRoute;

          return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _this$props = _this.props, client = _this$props.client, dispatch = _this$props.dispatch, handleSnackbarError = _this$props.handleSnackbarError;
                  mutate = client.mutate;
                  variables = {
                    input: {
                      userType: userType,
                      email: email,
                      password: password
                    }
                  };
                  _context.prev = 3;
                  _context.next = 6;
                  return mutate({
                    mutation: _apolloClient.loginMutation,
                    variables: variables
                  });

                case 6:
                  _ref5 = _context.sent;
                  data = _ref5.data;


                  localStorage.setItem('authToken', data.login);
                  desiredRoute = localStorage.getItem('desiredRoute') || redirect;


                  dispatch((0, _reactRouterRedux.push)(desiredRoute));
                  _context.next = 16;
                  break;

                case 13:
                  _context.prev = 13;
                  _context.t0 = _context['catch'](3);

                  handleSnackbarError(_context.t0);

                case 16:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this2, [[3, 13]]);
        }));

        return function (_x) {
          return _ref3.apply(this, arguments);
        };
      }(), _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(LoginPage, [{
      key: 'render',
      value: function render() {
        return _react2.default.createElement(
          'div',
          { className: 'grey-section-full' },
          _react2.default.createElement(
            'div',
            { className: 'max-width-div-center' },
            _react2.default.createElement(
              'h1',
              { className: '_2nd-header-copy' },
              'Login'
            ),
            _react2.default.createElement(
              'div',
              { className: 'log-in-form-block w-form' },
              _react2.default.createElement(_LoginForm2.default, { login: this.login }),
              _react2.default.createElement(
                'div',
                { className: 'log-in-links-container w-clearfix' },
                _react2.default.createElement(
                  _reactRouterDom.Link,
                  { className: 'register-link w-inline-block', to: '/register' },
                  _react2.default.createElement(
                    'div',
                    null,
                    'Register'
                  )
                ),
                _react2.default.createElement(
                  _reactRouterDom.Link,
                  { className: 'forgot-pw-link w-inline-block', to: '/forgot-password' },
                  _react2.default.createElement(
                    'div',
                    null,
                    'Forgot Password?'
                  )
                )
              )
            )
          )
        );
      }
    }]);

    return LoginPage;
  }(_react.Component);

  LoginPage.propTypes = {
    dispatch: _propTypes2.default.func.isRequired,
    client: _propTypes2.default.object.isRequired,
    handleSnackbarError: _propTypes2.default.func.isRequired
  };


  return (0, _reactRedux.connect)()((0, _reactApollo.withApollo)((0, _withAlertHandler2.default)(LoginPage)));
};

exports.default = createLoginPage;